{
  "0420c8cfb9f4056f": "Enter hour amount",
  "0a5d5c335cd87d5f": "Total spend",
  "0ebb39cc4c16c273": "Total Remaining Spend",
  "0efff1043328c356": "Estimated Total Spend",
  "0faaef05c2ec697d": "Edit Rate Boost Limit",
  "11924d5b6061804d": "Requesting an increase to the weekly rate boost limit.",
  "19766ed6ccb2f4a3": "Cancel",
  "1ce8564993cc9ca4": "Edit Spend Limit",
  "21fbde19cfb095cd": "Next week",
  "2d99e344a37673d9": "How many additional hours are needed for this week beyond the shifts already posted?",
  "36070f2eaf96bd11": "Additional hours",
  "377ad93554b126f9": "Estimated Total Hours",
  "3845725f02579dbd": "Set Spend Limit",
  "38593914ba8b6bb5": "Enable weekly limit",
  "4132287e112040eb": "Current weekly limit: {{limit}}",
  "47d2a515ef2f05b8": "Loading...",
  "4e9682fa850ed767": "hrs",
  "562361f9ac5ecfd1": "Track your weekly spend",
  "6a2769502a5dda78": "Previous month",
  "74cc8f1e7caf6b69": "Total remaining spend",
  "74e53211fef4b4d4": "Next month",
  "76900f1bfd16c8d4": "Back",
  "7d52938e8dfb7183": "Rate boosts",
  "7fb24165588aaad2": "Failed to load spending controls. Please try again.",
  "813ede96a15c4c82": "Enter value...",
  "8648fae145505743": "Limit increase requested",
  "8976f7983aefb33d": "Additional hours needed",
  "8a5fb7689fb2ff13": "Set Rate Boost Limit",
  "8c8900658a4c983f": "fields[workplace]=name",
  "920c2e9272d7c60d": "Apply to all upcoming weeks",
  "93483c938871b25a": "Weekly limit",
  "9a03073fb5cf415d": "Spend Controls",
  "a26984e36fa0880a": "Additional weekly boost spend ($)",
  "a68319de5050274b": "Estimated total hours",
  "ad96512f119ff9c4": "Spend increase request submitted.",
  "c0f8bbcd417656cf": "Previous week",
  "c1b24f6b30395848": "Request limit increase",
  "dc85af8f2b1d0d67": "Saving...",
  "e013d99a98ac54d0": "Request approval",
  "e0ab581aca1cd51a": "Total Remaining Hours",
  "e33a24e7fd82e2cf": "View and manage spend for your workplaces",
  "e5f88d676e85885b": "Total remaining hours",
  "eebdd24a77d9ad32": "Confirm",
  "efe7287d10ef5fe2": "Request Increase",
  "f226b929723805ed": "Enter dollar amount",
  "f6b545e21025ec1e": "Estimated total spend",
  "f7d718d88896690a": "Creating this shift exceeds the weekly spend limit set for your workplace. How many additional hours are needed for the week?",
  "fc5236e6362fb5f6": "Spend limit reached for the week of the shift"
}
